/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Shortcuts_TitleInputs */

const en_pc_tut_shortcuts_title = /** @type {(inputs: Pc_Tut_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft keyboard shortcuts`)
};

const zh_pc_tut_shortcuts_title = /** @type {(inputs: Pc_Tut_Shortcuts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 快捷键`)
};

/**
* | output |
* | --- |
* | "PdfCraft keyboard shortcuts" |
*
* @param {Pc_Tut_Shortcuts_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_shortcuts_title = /** @type {((inputs?: Pc_Tut_Shortcuts_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Shortcuts_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_shortcuts_title(inputs)
	return zh_pc_tut_shortcuts_title(inputs)
});
export { pc_tut_shortcuts_title as "pc.tut.shortcuts.title" }